var AppDispatcher = require('../dispatcher/app-dispatcher');
var Constants = require('../constants/global');
var FavoritesAPI = require('../utils/favorites-api');

var FavoritesActions = {

  add: function(placeId) {
    FavoritesAPI.add(placeId);
  },

  remove: function(placeId) {
    FavoritesAPI.remove(placeId);
  },

  updateView: function() {
    AppDispatcher.handleViewAction({
      actionType: Constants.UPDATE_FAVORITES
    });

  }

};

module.exports = FavoritesActions;



// WEBPACK FOOTER //
// ./actions/favorites-actions.js